import { Alert, Card, Col, Row } from "react-bootstrap";
import { QueryParamAggregation } from "../../../../../services/QueryParamService";

type Stat = { readonly label: string; readonly value: number };

const formatted = (value: number): string => value.toLocaleString("en-US");

const statsOf = ({ queryParams, totalUrlsWithParams }: QueryParamAggregation): Stat[] => [
  { label: "Query Parameters Found", value: queryParams.length },
  { label: "URLs with Params", value: totalUrlsWithParams },
  { label: "Total URL Count", value: queryParams.reduce((sum, param) => sum + param.urlCount, 0) },
];

const StatCard = ({ label, value }: Stat) => (
  <Col>
    <Card body>
      <div className="text-muted small">{label}</div>
      <div className="fs-4">{formatted(value)}</div>
    </Card>
  </Col>
);

const QueryParamSummary = ({ aggregation }: { readonly aggregation: QueryParamAggregation }) => (
  <div className="mb-3">
    <Row xs={2} md={3} className="g-3">
      {statsOf(aggregation).map((stat) => (
        <StatCard key={stat.label} {...stat} />
      ))}
    </Row>
    <Alert variant="info" className="mt-3 mb-0">
      <Alert.Heading as="h6">Counting Methodology</Alert.Heading>
      Note: URLs with multiple parameters are counted once for each parameter. For example,
      example.com?a=b&amp;c=d counts as 1 occurrence for 'a' and 1 for 'c'.
    </Alert>
  </div>
);

export default QueryParamSummary;
